import React from 'react';
import './AddIngredientModal.css';
import { SERVER_URL } from '../../../shared/apiConfig'; // Import SERVER_URL

const ViewIngredientModal = ({ isOpen, onClose, ingredient, handleEdit, handleDelete }) => {
    if (!isOpen) return null;

    return (
        <div className="modal">
            <div className="modal-content-ingredient-management">
                <span className="close-button" onClick={onClose}>&times;</span>
                <h2>Ingredient Details</h2>
                <p><strong>Name:</strong> {ingredient.name}</p>
                <p><strong>Category:</strong> {ingredient.categoryName}</p>
                <p><strong>Price (NOK):</strong> {ingredient.unitPrice}</p>
                {ingredient.imagePath ? (
                    <img
                        src={`${SERVER_URL}${ingredient.imagePath}`}
                        alt={ingredient.name}
                        className="ingredient-man-image"
                        onError={(e) => (e.target.src = '/images/default.png')} // Updated fallback image path
                    />
                ) : (
                    <img
                        src="/images/default.png" // Default image if no imagePath is provided
                        alt="Default"
                        className="ingredient-man-image"
                    />
                )}
                <p><strong>Fill Level:</strong> {ingredient.fillLevel || 0}%</p>
                <div>
                    <p><strong>Color:</strong></p>
                    <div
                        className="color-preview-large"
                        style={{
                            backgroundColor: ingredient.color || '#CCCCCC',
                            width: '100%',
                            height: '40px',
                            borderRadius: '4px',
                            border: '1px solid #ddd',
                            marginBottom: '15px'
                        }}
                    />
                </div>
                <p><strong>Available:</strong> {ingredient.isAvailable ? 'Yes' : 'No'}</p>
                <div className="ingredient-actions">
                    <button onClick={() => handleEdit(ingredient)} className="edit-button">
                        Edit
                    </button>
                    <button onClick={() => handleDelete(ingredient.ingredientId)} className="delete-button">
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewIngredientModal;